import React, { useEffect, useState } from 'react'
import { getUserTour, addPayment, editUserTourCustomer } from '../../../../../../redux/api/userTour.api'
import ReactQuill from 'react-quill'
import { Modal, notification, Tabs } from 'antd'

import './styles.scss'
import BookingDetails from './BookingDetails'
import TourDetails from './TourDetails'
import BookingAccommodations from './BookingAccommodations'
import BookingPayments from './BookingPayments'
import LoadingComp from '../../../../../components/LoadingComp'
import BookingItinery from './BookingItinery'
import { checkewayPayment } from '../../../../../../redux/api/payment.api'
import { TOUR_PACKAGE_PAYMENT } from '../../../../../constants/finance'
import moment from 'moment'
import { CloseCircleFilled, InfoCircleFilled } from '@ant-design/icons'

const TourBooking = () => {
    const url = window.location.pathname
    const tourId = url.split('/').pop()
    const [userTour, setUserTour] = useState(null)
    const [loading, setLoading] = useState(false)
    const [messageApi, contextHolder] = notification.useNotification();
    const [processingPayment, setProcessingPayment] = useState(false);
    const [paymentError, setPaymentError] = useState({
        type: null,
        title: null,
        message: null,
    });

    useEffect(() => {
        handleGetUserTour()
    }, [])

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            e.returnValue = 'Payment is processing. Are you sure you want to leave? This may result in payment or booking not being completed.';
            return e.returnValue;
        };
        
        if (processingPayment) {
            window.addEventListener('beforeunload', handler);

            return () => {
              window.removeEventListener('beforeunload', handler);
            };
        } else {
            window.removeEventListener('beforeunload', handler);
        }
    }, [processingPayment]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const accessCode = urlParams.get('AccessCode');
        const tourId = urlParams.get('tourId');
        const instalmentIndex = urlParams.get('instalmentIndex');
        const faildAttempt = urlParams.get('faildAttempt');
        const amount = urlParams.get('amount');
        const currency = urlParams.get('currency');
       
        if (accessCode && tourId && amount && currency && userTour && instalmentIndex)  {
            setProcessingPayment(true);
            const beforeUnload = (e) => {
                e.preventDefault();
                e.returnValue = 'Payment is processing. Please do not close or navigate away.';
            };
            window.onbeforeunload = beforeUnload;
            (async () => {
                try{
                    const paymentCheckRes = await checkewayPayment(accessCode);
                    
                    let paymentStatus = 'FAILED';
                    let shouldUpdateTour = false;
                    
                    if (paymentCheckRes?.data?.success && paymentCheckRes?.data?.transactionStatus) {
                        paymentStatus = 'COMPLETED';
                        shouldUpdateTour = true;
                    }

                    const now = new Date();
                    let paymentData, paymentRes, updateRes;
                    if (instalmentIndex !== null && instalmentIndex !== undefined && !isNaN(parseInt(instalmentIndex, 10))) {
                        
                        // Instalment payment
                        paymentData = {
                            userId: userTour.userId,
                            paidFor: 'TOUR_INSTALMENT',
                            paymentType: 'INSTALMENT',
                            paymentMethod: 'CARD',
                            paymentStatus: paymentStatus,
                            paymentAmount: amount,
                            paymentCurrency: currency,
                            paymentDate: now.toISOString().split('T')[0],
                            paymentTime: now.toTimeString().split(' ')[0],
                            paymentReference: `${tourId}-instalment-${parseInt(instalmentIndex, 10) + 1}`,
                            paymentGateway: 'EWAY',
                            paymentGatewayId: accessCode,
                            paymentGatewayResponse: JSON.stringify({ accessCode }),
                            paymentGatewayStatus: paymentStatus === 'COMPLETED' ? 'SUCCESS' : 'FAILED',
                            paymentGatewayReference: accessCode,
                            paymentGatewayAmount: amount,
                            paymentGatewayCurrency: currency,
                            paymentGatewayDate: now.toISOString().split('T')[0],
                            paymentGatewayTime: now.toTimeString().split(' ')[0],
                            paymentGatewayDescription: `Payment for instalment ${parseInt(instalmentIndex, 10) + 1} of tour ${tourId}`,
                        };
                        paymentRes = await addPayment(paymentData);

                        if (shouldUpdateTour) {
                            if (paymentRes.status === 201 || paymentRes.status === 200) {
                                const updatedInstalments = userTour.instalmentPayments.map((inst, idx) =>
                                    idx === parseInt(instalmentIndex, 10)
                                        ? { ...inst, isPaid: true, paymentId: paymentRes?.data?.id, paidAt: now.toISOString() }
                                        : inst
                                );
                                updateRes = await editUserTourCustomer({
                                    id: tourId,
                                    instalmentPayments: JSON.stringify(updatedInstalments),
                                });
    
                                if (updateRes.status === 200) {
                                    messageApi.success({ type: 'success', message: 'Payment Successful', description: 'Your payment and booking update were successful.' });
                                } else {
                                    setPaymentError({
                                        type: 'error',
                                        title: 'Error Updating Booking',
                                        message: `Payment was successful, but booking update failed. Please contact support.`
                                    })
                                }
                            } else {
                                setPaymentError({
                                    type: 'error',
                                    title: 'Payment Recording Failed',
                                    message: `Payment was successful, but booking update failed. Please contact support.`
                                })
                            }
                        } else {
                            setPaymentError({
                                type: 'error',
                                title: 'Payment Failed',
                                message: 'Payment was unsuccessful. Please try again or contact support.'
                            })
                        }
                    }
                } catch (error) {
                    setPaymentError({
                        type: 'error',
                        title: 'Payment Processing Error',
                        message: 'An error occurred while processing your payment. Please contact support.'
                    })
                }
                window.onbeforeunload = null;
                setProcessingPayment(false);
                await handleGetUserTour();
                window.history.replaceState({}, document.title, window.location.pathname); // clear params
            })();
        }

        if (accessCode && tourId && amount && currency && userTour && faildAttempt) {
            setProcessingPayment(true);

            const beforeUnload = (e) => {
                e.preventDefault();
                e.returnValue = 'Payment is processing. Please do not close or navigate away.';
            };
            window.addEventListener('beforeunload', beforeUnload);
            const blockNav = (e) => {
                e.preventDefault();
                return false;
            };
            window.history.pushState(null, null, window.location.href);
            window.addEventListener('popstate', blockNav);

            (async () => {
                try {
                console.log('accessCode', accessCode)
                    const paymentCheckRes = await checkewayPayment(accessCode);
                    
                    let paymentStatus = 'FAILED';
                    let shouldUpdateTour = false;
                    
                    if (paymentCheckRes?.data?.success && paymentCheckRes?.data?.transactionStatus) {
                        paymentStatus = 'COMPLETED';
                        shouldUpdateTour = true;
                    }

                    const paymentData = {
                        userId: userTour.userId,
                        paidFor: tourId,
                        paymentType: TOUR_PACKAGE_PAYMENT,
                        paymentMethod: 'CARD',
                        paymentStatus,
                        paymentAmount: amount,
                        paymentCurrency: currency,
                        paymentDate: moment().format('MMM D YYYY h:mma'),
                        paymentTime: moment().format('h:mma'),
                        paymentReference: `Booking ID (${tourId})`,
                        paymentGateway: 'EWAY',
                        paymentGatewayId: accessCode,
                        paymentGatewayResponse: JSON.stringify(paymentCheckRes?.data || {}),
                        paymentGatewayStatus: paymentStatus === 'COMPLETED' ? 'SUCCESS' : 'FAILED',
                        paymentGatewayReference: paymentCheckRes?.data?.transactionId?.toString() || accessCode,
                        paymentGatewayAmount: amount,
                        paymentGatewayCurrency: currency,
                        paymentGatewayDate: moment().format('MMM D YYYY h:mma'),
                        paymentGatewayTime: moment().format('h:mma'),
                        paymentGatewayDescription: `Payment for tour booking ${tourId}`,
                    };

                    const paymentRes = await addPayment(paymentData);
                    
                    if (shouldUpdateTour) {
                        if (paymentRes.status === 201 || paymentRes.status === 200) {
                            const updateRes = await editUserTourCustomer({
                                id: tourId,
                                paymentStatus: 'PAID',
                                bookingStatus: 'CONFIRMED',
                                paymentId: paymentRes?.data?.id,
                                paidAt: moment().format('MMM D YYYY h:mma'),
                                instalmentPayments: null
                            });
                            
                            if (updateRes.status === 200) {
                                messageApi.open({ 
                                    type: 'success', 
                                    message: 'Payment Successful', 
                                    description: 'Your payment and booking have been confirmed successfully.' 
                                });
                               
                            } else {
                                setPaymentError({
                                    type: 'error',
                                    title: 'Error Updating Booking',
                                    message: `Payment was successful, but booking update failed. Please contact support.`
                                })
                            }
                        } else {
                            setPaymentError({
                                type: 'error',
                                title: 'Payment Recording Failed',
                                message: `Payment was successful, but booking update failed. Please contact support.`
                            })
                        }
                    } else {
                        setPaymentError({
                            type: 'error',
                            title: 'Payment Failed',
                            message: 'Payment was unsuccessful. Please try again or contact support.'
                        })
                    }
                } catch (error) {
                    setPaymentError({
                        type: 'error',
                        title: 'Payment Processing Error',
                        message: 'An error occurred while processing your payment. Please contact support.'
                    })
                }
                
                window.removeEventListener('beforeunload', beforeUnload);
                window.removeEventListener('popstate', blockNav);
                setProcessingPayment(false);
                await handleGetUserTour();
                window.history.replaceState({}, document.title, window.location.pathname); 
            })();
        }

        // eslint-disable-next-line
    }, [window.location.search, userTour]);

    const handleGetUserTour = async () => {
        setLoading(true)
        try {
            const response = await getUserTour(tourId)
            setUserTour(response.data)
        } catch (error) {
            console.log('ERROR GETTING USER TOUR', error)
        }
        setLoading(false)
    }

    const items = [
        {
            key: '1',
            label: 'Booking Details',
            children: <BookingDetails userTour={userTour} handleGetUserTour={handleGetUserTour} messageApi={messageApi} />
        },
        {
            key: '2',
            label: 'Tour Details',
            children: <TourDetails userTour={userTour} />
        },
        {
            key: '3',
            label: 'Tour Accommodation',
            children: <BookingAccommodations userTour={userTour} />
        },
        {
            key: '4',
            label: 'Payments',
            children: <BookingPayments userTour={userTour} />
        },
        {
            key: '5',
            label: 'Itinerary',
            children: <BookingItinery userTour={userTour} handleGetUserTour={handleGetUserTour} />
        },
        // {
        //     key: '5',
        //     label: 'Chat',
        //     children: <div>Heloo</div>
        // },
        // {
        //     key: '6',
        //     label: 'Reviews',
        //     children: <div>Heloo</div>
        // }
    ]

    return (
        <div className='personal_details tour_booking_details_container'>
            {contextHolder}
            {processingPayment && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: 'rgba(255,255,255,0.95)',
                    zIndex: 9999,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <LoadingComp />
                    <div style={{ marginTop: 24, fontSize: 20, color: '#333', fontWeight: 500 }}>
                        Processing your payment. Please do not close or navigate away.
                    </div>
                </div>
            )}
            {!loading ? <>
                <h1 className='heder_2'>
                    {userTour?.tourPackage?.packageName}
                </h1>
                <ReactQuill
                    value={userTour?.tourPackage?.shotDescription}
                    readOnly={true}
                    theme='bubble'
                    style={{ margin: '10px 0' }}
                />
                <div className='tour_booking_details'>
                    <Tabs
                        defaultActiveKey="1"
                        items={items}
                    />
                </div>
            </>
                :
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '50vh'
                    }}
                >
                    <LoadingComp />
                </div>
            }
            <Modal
                open={paymentError.type}
                onCancel={() => setPaymentError({
                    type: null,
                    title: null,
                    message: null,
                })}
                footer={null}
                width={450}
                centered
                >
                <div className='payment_error'>
                    <div className='payment_error_title'
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <div className='payment_error_title_icon'>
                            {
                                paymentError.type === 'error' ? (
                                    <CloseCircleFilled style={{ color: 'red' , fontSize: 25, marginRight: 10 }} />
                                ) : (
                                    <InfoCircleFilled style={{ color: 'red' , fontSize: 25, marginRight: 10 }} />
                                )
                            }
                        </div>
                        <div className='payment_error_title_text'>
                            <h3>{paymentError.title}</h3>
                        </div>
                    </div>

                    <p>{paymentError.message}</p>
                </div>
            </Modal>
        </div>
    )
}

export default TourBooking